import packageInfo from '../../package.json';
export const environment = {
  appVersion: packageInfo.version,
  production: false,
  ForceApiKey: "ulO66nVd8FvzMe$oyiGzfr!KKiD+fh7K4Q+ZzxB72J*4#ISNKBQDYMAiIPVL&amp;9v$NeF5bTny57wiHFwQC%H=5Bk35bzaUE7f5VPGtM1hNiT2ld-JgfY1NoG*6NvO14SK",
  encryptSecretKey: "40770396da6eb48eaeb49ecb63b0553088e72dc5117511d7f36442f897035930",
  baseUrl: 'https://coreapi.spikyarc.net/api/',
  BASE_URL_LOGIN: 'https://coreapi.spikyarc.net/',
  PHOTO_URL: 'http://localhost:8080/API/Documents/Photos/LabourPhotos/',
  DOC_URL: 'http://localhost:8080/API/Documents/TaskDocuments/',
  idleTime: 10 ,
  
}